export const StyleAutocomplete = {
  marginTop: 1,
  marginBottom: 1,
  "& .MuiOutlinedInput-notchedOutline": {
    border: 0,
  },
  "& .MuiInputBase-root": {
    fontSize: "14px",
    border: "1px solid #D1D3D4",
    borderRadius: "4px",
    height: "41px",
    lineHeight: "40px",
    paddingLeft: "12px",
    boxSizing: "border-box",
  },
  "& .MuiFormLabel-root:not(.Mui-focused)": {
    top: "-6px",
  },
};
